import React from "react";
import { Route, Routes, Navigate, useLocation } from "react-router-dom";

import { useNavigationBar } from "../../context/NavigationContext";
import ListApplications from "./listApplication";
import ApplicationDetail from "./details";
import ApplicationLayout from "./AppplicationLayout";

const Application = () => {
  const location = useLocation();
  const { backgroundLocation } = useNavigationBar();
  //const state = location.state as { backgroundLocation?: Location };
  const oldLocation = backgroundLocation?.pathname.includes("dashboard/applications") ? backgroundLocation : location;

  return (
    <>
      {/* <Routes location={background || location}> */}
      <Routes location={oldLocation}>
        <Route path="/" element={<ListApplications />} />
        <Route element={<ApplicationLayout />}>
          <Route path="/:id" element={<ApplicationDetail />} />
        </Route>
      </Routes>
      {backgroundLocation && (
        <Routes>
          <Route element={<ApplicationLayout />}>
            <Route path="/:id" element={<ApplicationDetail />} />
          </Route>
        </Routes>
      )}
    </>
  );
};

export default Application;
